import React from "react";
import {connect} from "react-redux";
import UeberUns from "../components/UeberUns";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class UeberUnsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshPageController: false
        }
    }

    render() {
        return (
            <div>
                <UeberUns />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UeberUnsContainer);


// WEBPACK FOOTER //
// ./src/container/UeberUnsContainer.js